import { Rate, RateProps } from 'antd';
import { FC } from 'react';

export const ILSRate: FC<RateProps> = (props) => {
  return <Rate {...props} />;
};
